import { createContext, useContext, useEffect } from 'react';
type ResortListContextType = {
  resortList: Array<ResortListItem>;
  setResortList: () => void;
};
export const ResortListContext = createContext<ResortListContextType>({
  resortList: [],
  setResortList: () => {},
});
export const useResortList = () => {
  const context = useContext(ResortListContext);

  if (context === undefined) {
    throw new Error('useResortList must be used within a ResortListContext.Provider');
  }

  useEffect(() => {
    context.setResortList();
  }, []);
  return context.resortList;
};
